import React from 'react';
import { useTheme } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';
import Chart from 'react-apexcharts';
import { Box } from '@mui/material';
import { traducciones } from '../../views/pages/operator/ProductionRecordsPage';

const ProductionVsTargetSimpleChart = ({
    chartData = ([] = []),
    height = 350,
    showLabel = true,
    isDarkMode = false,
    showToolbar = true,
    target = 0
}) => {
    const theme = useTheme();
    const fontFamily = `Inter, sans-serif`;

    const BAR_COLOR = isDarkMode ? '#FFFFFF' : theme.palette.primary.main; // verde normal
    const LINE_COLOR = theme.palette.secondary.dark;
    const AXIS_COLOR = isDarkMode ? '#FFFFFF' : theme.palette.grey[700];

    const hours = chartData.map((p) => (p.hour ? p.hour.substring(0, 5) : ''));
    const produced = chartData.map((p) => p.produced ?? 0);

    const options = {
        chart: {
            type: 'line',
            fontFamily,
            height: height,
            locales: [traducciones],
            defaultLocale: 'es',
            animations: {
                enabled: false
            },
            toolbar: {
                show: showToolbar,
                export: {
                    csv: {
                        filename: `Gráfico de producción vs meta.`,
                        headerCategory: 'Horas'
                    },
                    svg: { filename: `Gráfico de producción vs meta.` },
                    png: { filename: `Gráfico de producción vs meta.` }
                }
            }
        },
        noData: {
            text: 'No hay datos disponibles',
            align: 'center',
            verticalAlign: 'middle',
            style: {
                color: AXIS_COLOR,
                fontSize: '16px',
                fontFamily: fontFamily
            }
        },
        plotOptions: {
            bar: {
                columnWidth: '70%',
                borderRadius: 0
            }
        },
        stroke: {
            curve: 'smooth',
            width: [3, 0] // línea visible, barras no
        },
        dataLabels: {
            enabled: true,
            enabledOnSeries: [0], // ✅ misma línea
            formatter: (val) => {
                if (val === null || val === undefined || val === 0) return '';
                return val;
            },
            style: {
                fontSize: '16px',
                fontWeight: 'bold',
                fontFamily
            },
            background: {
                enabled: true,
                borderRadius: 4,
                padding: 4,
                opacity: 0.9,
                background: LINE_COLOR
            }
        },
        xaxis: {
            categories: hours,
            tickAmount: 8,
            labels: {
                style: {
                    colors: AXIS_COLOR,
                    fontSize: '16px'
                }
            },

            axisBorder: {
                show: true,
                color: AXIS_COLOR
            },
            axisTicks: {
                show: true,
                color: AXIS_COLOR
            }
        },

        yaxis: [
            {
                seriesName: 'Cantidad',
                min: 0,
                max: Math.max(...produced, target) * 1.2,
                title: { text: 'Cantidad', style: { color: AXIS_COLOR, fontSize: '16px' } },
                labels: {
                    style: { colors: AXIS_COLOR, fontSize: '16px' }
                }
            }
        ],

        tooltip: {
            theme: isDarkMode ? 'dark' : 'light',
            shared: true,
            intersect: false
        },

        legend: {
            position: 'bottom',
            fontFamily,
            labels: {
                colors: AXIS_COLOR
            }
        },

        colors: [LINE_COLOR, BAR_COLOR],
        annotations: {
            yaxis: [
                {
                    y: target, // 🔥 tu meta
                    borderColor: 'red',
                    strokeDashArray: 10, // línea punteada
                    label: {
                        text: `Meta: ${target}`,
                        style: {
                            color: 'white',
                            background: 'red',
                            fontSize: '15px',
                            fontFamily
                        }
                    }
                }
            ]
        }
    };

    const chartSeries = [
        {
            name: 'Producción',
            type: 'line',
            data: produced
        }
        // {
        //     name: 'Producción (acumulada)',
        //     type: 'bar',
        //     data: producedAccumulated
        // }
    ];

    return (
        <Box>
            {showLabel && (
                <MuiTypography variant="h5" component="p" sx={{ fontWeight: 400, textAlign: 'center', color: 'gray' }}>
                    Meta vs producción por hora
                </MuiTypography>
            )}

            <Chart options={options} series={chartSeries} height={height} />
        </Box>
    );
};

export default ProductionVsTargetSimpleChart;
